import { Injectable } from '@angular/core';
import { EmployeeJobPositionModel } from './model/employee-job-position.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmployeeJobPositionService {

  constructor(private http: HttpClient) { }

  getList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/hr/employee-job-positions/list', requestData);
  }

  getById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/employee-job-position/get/' + id, '');
  }

  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(environment.baseUrl + '/employee-job-position/exportdatacsv', requestData, { headers, responseType: 'blob' });
  }

  update(info: EmployeeJobPositionModel): Observable<any> {
    if (info.hasOwnProperty("id") && info.id !== 0) {
      return this.http.post(environment.baseUrl + '/employee-job-position/update', info);
    } else {
      return this.http.post(environment.baseUrl + '/employee-job-position/add', info);
    }
  }

  delete(info: EmployeeJobPositionModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/employee-job-position/delete/' + info.id, info);
  }
}
